var map = {
	"./BOOST.svg": 2398,
	"./GRAB.svg": 2399,
	"./MBB.svg": 2400,
	"./TNG.svg": 2401,
	"./direpay.svg": 2402,
	"./doitnow.svg": 2403,
	"./duitnow.svg": 2404,
	"./fpay.svg": 2405,
	"./fpay2.svg": 2406,
	"./fpx.svg": 2407,
	"./online_banking.svg": 2408,
	"./rapidpays.svg": 2409,
	"./secret_pay.svg": 2410,
	"./secret_pay_offline.svg": 2411,
	"./secret_pay_pro.svg": 2412,
	"./secret_pay_pro_b.svg": 2413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 216;